module.exports = __webpack_public_path__ + "static/invite-btn.f8f59a32.png";